"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTappableCard = void 0;
const styles_1 = require("@mui/material/styles");
const tappable_card_1 = __importStar(require("../tappable-card"));
exports.StyledTappableCard = (0, styles_1.styled)(tappable_card_1.default)({
    boxShadow: "none",
    "&:hover": {
        boxShadow: "none"
    },
    [`.${tappable_card_1.tappableCardClasses.body}`]: {
        padding: "30px 0px 0px"
    },
    [`.${tappable_card_1.tappableCardClasses.brandLogo}`]: {
        marginLeft: -5
    },
    [`.${tappable_card_1.tappableCardClasses.footer}`]: {
        padding: "36px 0px"
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3N0b3J5LWNhcmQvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsaURBQThDO0FBQzlDLGtFQUFxRTtBQUV4RCxRQUFBLGtCQUFrQixHQUFHLElBQUEsZUFBTSxFQUFDLHVCQUFZLENBQUMsQ0FBQztJQUNyRCxTQUFTLEVBQUUsTUFBTTtJQUNqQixTQUFTLEVBQUU7UUFDVCxTQUFTLEVBQUUsTUFBTTtLQUNsQjtJQUNELENBQUMsSUFBSSxtQ0FBbUIsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1FBQ2hDLE9BQU8sRUFBRSxjQUFjO0tBQ3hCO0lBQ0QsQ0FBQyxJQUFJLG1DQUFtQixDQUFDLFNBQVMsRUFBRSxDQUFDLEVBQUU7UUFDckMsVUFBVSxFQUFFLENBQUMsQ0FBQztLQUNmO0lBQ0QsQ0FBQyxJQUFJLG1DQUFtQixDQUFDLE1BQU0sRUFBRSxDQUFDLEVBQUU7UUFDbEMsT0FBTyxFQUFFLFVBQVU7S0FDcEI7Q0FDRixDQUFDLENBQUMifQ==